import { render, staticRenderFns } from "./SessionsCrud.vue?vue&type=template&id=52caf922&scoped=true"
import script from "./SessionsCrud.vue?vue&type=script&lang=js"
export * from "./SessionsCrud.vue?vue&type=script&lang=js"
import style0 from "./SessionsCrud.vue?vue&type=style&index=0&id=52caf922&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52caf922",
  null
  
)

export default component.exports